export enum Privacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  ForFriends = 'FOR_FRIENDS',
}
